import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles, articleCategories } from '@/mocks/articles';

export default function ArticlesPage() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredArticles = useMemo(() => {
    if (activeCategory === 'all') return articles;
    return articles.filter((a) => a.categorySlug === activeCategory);
  }, [activeCategory]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <main className="pt-16 min-h-screen bg-background-50">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '建站学院' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4">
                建站学院
              </h1>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto">
                从入门到精通，掌握建站技巧、SEO优化和网站运营的方方面面
              </p>
            </div>

            <div className="flex items-center justify-center gap-2 flex-wrap mb-12">
              {articleCategories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveCategory(cat.slug)}
                  className={`px-4 py-2 text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    cat.slug === activeCategory
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 border border-background-200/70'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="flex flex-col gap-6">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  onClick={scrollToTop}
                  className="group flex flex-col sm:flex-row gap-5 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className="text-xs px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                      <span className="text-xs text-foreground-400">{article.readTime}阅读</span>
                    </div>
                    <h2 className="text-lg font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-2 flex-wrap">
                      {article.tags.map((tag) => (
                        <span key={tag} className="text-xs text-foreground-400">
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}